




import Vue from 'vue'
import { mapState } from 'vuex'
import { shuffle } from '../helper/helper'
import { settings } from '../gameSettings'
import { jobCards } from '../data/jobcards'
import { topCards } from '../data/topcards'
import { flopCards } from '../data/flopcards'
import { Player, CardSet, GameStatus, Mapper, Connection } from '../types'
// import Pusher from 'vue-pusher'
import axios from 'axios'
import Pusher from 'pusher-js'

export default Vue.extend({
  name: 'GameMaster',
  props: [
    'players',
    'gameId',
    'gameMasterUseSalaryExpectations',
    'gameMasterUseEducation',
    'gameMasterUseInitiativeApplication',
  ],
  data: function() {
    return {
      round: 0,
      scoring: {} as any,
      connections: {} as Mapper<Connection>,
      status: GameStatus.gameStarted as GameStatus,
      theGameStatus: GameStatus,
      pusher: {} as Pusher,
      applications: [] as Array<any>,
      applicationsReady: 0,
      picks: [] as Array<any>,
      picksShown: [] as Array<number>,
      applicationMatchShown: [] as Array<number>,
      playersWithInitiativeApplication: [] as Array<string>,
      top: {
        index: 0,
        values: topCards,
      },
      flop: {
        index: 0,
        values: flopCards,
      },
      job: {
        index: 0,
        values: jobCards,
      },
    }
  },
  methods: {
    dealInitialCards() {
      const data = {} as any
      this.players.forEach((player: string) => {
        this.scoring[player] = {
          pointsThisRound: 0,
          pointsTotal: 0,
          name: player,
        }
      })
      this.players.forEach((player: string) => {
        const initialCards = {
          top: this.getNextCards(this.top, settings.initalCards.top),
          job: this.getNextCards(this.job, settings.initalCards.job),
          flop: this.getNextCards(this.flop, settings.initalCards.flop),
        }
        data[this.gameId + '_' + player] = {
          id: 'initialCards',
          data: {
            initialCards: initialCards,
            scoring: this.scoring,
            additionalGameElements: {
              useSalaryExpectations: this.gameMasterUseSalaryExpectations,
              useEducation: this.gameMasterUseEducation,
              useInitiativeApplication: this.gameMasterUseInitiativeApplication,
            },
          },
        }
      })
      //this.sendData(data)
      //this.status = GameStatus.startNextRound
      this.startNewRound(data)
      //window.setTimeout(this.startNewRound, 500)
    },
    dealNewCards() {
      const data = {} as any
      this.players.forEach((player: string) => {
        const extraCards = this.playersWithInitiativeApplication.includes(
          player
        )
          ? 1
          : 0
        const redrawCards = {
          top: this.getNextCards(
            this.top,
            settings.redrawCards.top + extraCards
          ),
          job: this.getNextCards(
            this.job,
            settings.redrawCards.job + extraCards
          ),
          flop: this.getNextCards(
            this.flop,
            settings.redrawCards.flop + extraCards
          ),
        }
        data[this.gameId + '_' + player] = {
          id: 'redrawCards',
          data: {
            redrawCards: redrawCards,
          },
        }
      })
      this.startNewRound(data)
    },
    dealEducationCards(message: any) {
      const redrawCards = {
        top: this.getNextCards(this.top, message.numberOfCards.top),
        job: this.getNextCards(this.job, message.numberOfCards.job),
        flop: this.getNextCards(this.flop, message.numberOfCards.flop),
      }

      const data = {} as any
      data[this.gameId + '_' + message.player] = {
        id: 'getEducationCards',
        data: {
          redrawCards: redrawCards,
        },
      }
      this.sendData(data)
    },
    getNextCards(cardSet: CardSet, numberOfCards: number): string[] {
      if (cardSet.index + numberOfCards > cardSet.values.length) {
        //TODO
        console.warn('MISCHEN')
        cardSet.index = 0
        cardSet.values = shuffle(cardSet.values)
      }
      const cards = cardSet.values.slice(
        cardSet.index,
        cardSet.index + numberOfCards
      )
      cardSet.index += numberOfCards
      return cards
    },
    startNewRound(data: any) {
      this.round++
      this.applications = []
      this.applicationsReady = 0
      this.picks = []
      this.connections = {}
      this.picksShown = []
      this.applicationMatchShown = []
      this.playersWithInitiativeApplication = []
      if (this.round == this.players.length) {
        this.round = 1
      }
      for (let i = 0; i < this.players.length; i++) {
        this.connections[this.players[i]] = {
          job: '',
          boss: this.players[i],
          applicant: this.players[(i + this.round) % this.players.length],
          ready: false,
        }
      }

      this.players.forEach((player: string) => {
        data[this.gameId + '_' + player].data.connections = this.connections
      })
      this.sendData(data)
      this.status = GameStatus.waitForApplications
    },
    sendApplications() {
      const data = {
        allPlayers: {
          id: 'allApplicationsReady',
          data: {
            applications: this.applications,
            currentNextButtonPusher: this.getRandomPlayerName(),
          },
        },
      }
      this.sendData(data)
      this.status = GameStatus.waitForPicks
    },
    sendPicks() {
      const data = {
        allPlayers: {
          id: 'allPicksReady',
          data: {
            applications: this.applications,
            currentNextButtonPusher: this.getRandomPlayerName(),
          },
        },
      }
      this.sendData(data)
      this.status = GameStatus.showResults
    },
    doTheScoring() {
      this.players.forEach((player: string) => {
        this.scoring[player].pointsThisRound = 0
      })

      this.picks.forEach((pick: any) => {
        if (pick.player == this.applications[pick.applicationIndex].boss) {
          this.scoring[pick.player].pointsThisRound++
          this.scoring[pick.player].pointsTotal++
          this.scoring[
            this.applications[pick.applicationIndex].applicant
          ].pointsThisRound += this.applications[
            pick.applicationIndex
          ].salaryExpectation
          this.scoring[
            this.applications[pick.applicationIndex].applicant
          ].pointsTotal += this.applications[
            pick.applicationIndex
          ].salaryExpectation
        }
      })
      const data = {
        allPlayers: {
          id: 'showScoring',
          data: {
            scoring: this.scoring,
          },
        },
      }
      this.sendData(data)
      this.status = GameStatus.redrawCards
    },
    handleMessage(message: any) {
      switch (message.id) {
        case 'applicationReady': {
          message.data.pickers = []
          message.data.showPickers = false
          message.data.showMatch = false
          message.data.open = false
          message.data.isInitiative = false
          this.applicationsReady++
          this.applications.push(message.data)
          if (this.applicationsReady == this.players.length) {
            this.applications = shuffle(this.applications)
            this.sendApplications()
          }
          break
        }
        case 'initiativeApplicationReady': {
          message.data.pickers = []
          message.data.showPickers = false
          message.data.showMatch = false
          message.data.open = false
          message.data.isInitiative = true
          this.applications.push(message.data)
          break
        }
        case 'pickApplication': {
          this.picks.push(message.data)
          this.applications[message.data.applicationIndex].pickers.push(
            message.data.player
          )
          if (this.picks.length == this.players.length) {
            this.sendPicks()
          }
          break
        }
        case 'doTheScoring': {
          this.doTheScoring()
          break
        }
        case 'startNewRound': {
          this.dealNewCards()
          break
        }
        case 'useAction': {
          switch (message.data.action) {
            case 'education':
              this.dealEducationCards(message.data)
              break
            case 'initiativeApplication':
              this.playersWithInitiativeApplication.push(message.data.player)
              break
            default:
              console.log('unknown action: ' + message.data.action)
              break
          }
          break
        }
        default:
          console.log('unknown id: ' + message.id)
      }
    },

    getRandomPlayerName() {
      return this.players[Math.floor(Math.random() * this.players.length)]
    },

    sendData(data: any) {
      const url =
        'https://headhunter.donvanone.de/backend/src/headhunter.php?prefix=' +
        this.gameId
      axios.get(url, {
        params: {
          data: data,
        },
      })
    },
  },
  mounted: function() {
    this.top.values = shuffle(this.top.values)
    this.job.values = shuffle(this.job.values)
    this.flop.values = shuffle(this.flop.values)
    this.status = GameStatus.gameStarted

    //Debug
    //Pusher.logToConsole = true

    this.pusher = new Pusher('f73f146117c4f8e6351d', {
      cluster: 'eu',
      forceTLS: true,
    })

    const channel = this.pusher.subscribe(this.gameId + '_gameMaster')
    channel.bind('gameMaster', (data: any) => {
      this.handleMessage(data)
    })

    this.dealInitialCards()
  },
})
